import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientOrderListItemDto, ClientOrderStatus } from './models/client-order-list-item.dto';

@Injectable({ providedIn: 'root' })
export class ClientOrdersProvider {
  constructor(private http: HttpClient) {}

  getClientOrders(search?: string, status?: ClientOrderStatus): Observable<ClientOrderListItemDto[]> {
    const url = '/api/client-orders';

    const params: { search?: string, status?: number } = {};

    if (search) {
      params.search = search;
    }

    if (status !== undefined) {
      params.status = status;
    }

    return this.http.get<ClientOrderListItemDto[]>(url, { params });
  }
}
